// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuoteCard {
    margin: 32px auto;
    padding: 32px;
    background-color: var(--light);
    display: grid;
    grid-template-columns: 4fr 1fr;
    grid-gap: 16px;
    border-radius: 6px;
    box-shadow: var(--box-shadow);
    max-width: 900px;
}

.QuoteCard div {
    z-index: 0;
}

.QuoteCard i {
    position: absolute;
    font-size: 3.5rem;
    color: var(--dark);
    opacity: 0.2;
    filter: var(--shadow);
}

.QuoteCard p {
    padding-left: 15px;
    z-index: 10;
}

/* div holding image */
.QuoteCard > div {
    display: flex;
    align-items: center;
}

.QuoteCard .right {
    justify-content: center;
}

.QuoteCard .left {
    flex-direction: column;
    align-items: flex-start;
}

.QuoteCard img {
    width: 100%;
    max-width: 150px;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: var(--box-shadow);
}

@media (max-width: 1150px) {
    .QuoteCard {
        grid-template-columns: 3fr 1fr;
    }
}

@media (max-width: 1000px) {
    .QuoteCard {
        grid-template-columns: 1fr;
        grid-gap: 0px;
    }
}

@media (max-width: 950px) {
    .QuoteCard {
        grid-template-columns: 3fr 1fr;
        grid-gap: 16px;
    }
}

@media (max-width: 600px) {
    .QuoteCard {
        grid-template-columns: 1fr;
        grid-gap: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/QuoteCard.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,aAAa;IACjB;AACJ","sourcesContent":[".QuoteCard {\n    margin: 32px auto;\n    padding: 32px;\n    background-color: var(--light);\n    display: grid;\n    grid-template-columns: 4fr 1fr;\n    grid-gap: 16px;\n    border-radius: 6px;\n    box-shadow: var(--box-shadow);\n    max-width: 900px;\n}\n\n.QuoteCard div {\n    z-index: 0;\n}\n\n.QuoteCard i {\n    position: absolute;\n    font-size: 3.5rem;\n    color: var(--dark);\n    opacity: 0.2;\n    filter: var(--shadow);\n}\n\n.QuoteCard p {\n    padding-left: 15px;\n    z-index: 10;\n}\n\n/* div holding image */\n.QuoteCard > div {\n    display: flex;\n    align-items: center;\n}\n\n.QuoteCard .right {\n    justify-content: center;\n}\n\n.QuoteCard .left {\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.QuoteCard img {\n    width: 100%;\n    max-width: 150px;\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    border-radius: 50%;\n    box-shadow: var(--box-shadow);\n}\n\n@media (max-width: 1150px) {\n    .QuoteCard {\n        grid-template-columns: 3fr 1fr;\n    }\n}\n\n@media (max-width: 1000px) {\n    .QuoteCard {\n        grid-template-columns: 1fr;\n        grid-gap: 0px;\n    }\n}\n\n@media (max-width: 950px) {\n    .QuoteCard {\n        grid-template-columns: 3fr 1fr;\n        grid-gap: 16px;\n    }\n}\n\n@media (max-width: 600px) {\n    .QuoteCard {\n        grid-template-columns: 1fr;\n        grid-gap: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
